import { render, staticRenderFns } from "./TotalMentalHealthHome.vue?vue&type=template&id=529fd53a"
import script from "./TotalMentalHealthHome.vue?vue&type=script&lang=js"
export * from "./TotalMentalHealthHome.vue?vue&type=script&lang=js"
import style0 from "./TotalMentalHealthHome.vue?vue&type=style&index=0&id=529fd53a&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports